import React from "react";
import AllActiveBuyer from "../ActiveBuyerList/AllActiveBuyer";

const TrashBuyers = () => {
  
    const HiddenForTrash = "hidden";
    const Heading = "Trash"

    return (
        <div className="w-full">
            <AllActiveBuyer message={"hidden import"} Heading={Heading}/>
        </div>
    );
};

export default TrashBuyers;
